import { getPathFromState, getStateFromPath, } from '@react-navigation/native';
import { SEO_OMIT_PARAM_SET } from './seoOmitParams';
function cleanRouteParams(params) {
    if (!params) {
        return params;
    }
    const cleaned = {};
    for (const [key, value] of Object.entries(params)) {
        if (!SEO_OMIT_PARAM_SET.has(key)) {
            cleaned[key] = value;
        }
    }
    return cleaned;
}
export function cleanNavigationStateForSeo(state) {
    if (!state.routes) {
        return state;
    }
    return {
        ...state,
        routes: state.routes.map(route => ({
            ...route,
            params: cleanRouteParams(route.params),
            ...(route.state
                ? { state: cleanNavigationStateForSeo(route.state) }
                : {}),
        })),
    };
}
export function getSeoPathFromState(state, config) {
    return getPathFromState(cleanNavigationStateForSeo(state), config);
}
export function getSeoStateFromPath(path, config) {
    const state = getStateFromPath(path, config);
    return state ? cleanNavigationStateForSeo(state) : state;
}
